import { ReactNode } from 'react';
import { RadioField, useControlledField } from '@frontend/design-system';

type FilterItemPopoverRadioFieldProps = {
  label: string;
  onChange: (selected: string) => void;
  options: string[];
  value?: string;
  displayValue?: ReactNode;
};

export function FilterItemPopoverRadioField({
  label,
  onChange,
  options,
  value,
  displayValue,
}: FilterItemPopoverRadioFieldProps) {
  const radiolistProps = useControlledField({
    onChange: (newValue) => {
      if (newValue) {
        onChange(newValue);
      }
    },
    type: 'radio',
    value,
  });

  return (
    <RadioField {...radiolistProps} label={label} name={options[0]}>
      {options.map((key) => (
        <RadioField.Radio
          key={key}
          value={key}
          css={{
            margin: 0,
          }}
        >
          {displayValue}
        </RadioField.Radio>
      ))}
    </RadioField>
  );
}
